const increaseSpecificity = `
	&& 
`;

const specificity = {
  increaseSpecificity,
};

export default specificity;
